const ENDPOINT = "https://skillsuprise.com/"
export default ENDPOINT